import {Modal} from 'bootstrap'


document.addEventListener('alpine:init', () => {
  Alpine.data('header', () => ({
    // data and model
      currentRoute: '',


      // @methods
      handlePatchChange() {
        const path = window.location.hash.replaceAll('#/', '')
        this.currentRoute = path
      },

      // @initialize
      init() {
        window.addEventListener('locationchange', ()=> {
          this.handlePatchChange()
        });
        // init when load
        this.handlePatchChange()

        // init default url opened

        if(this.currentRoute?.length == 0) {
          if(window.defaultUrl) {
            window.location.hash = window.defaultUrl
          }
        }   
      }
  }))
})
